var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckedBox = function SvgCheckedBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.521 19.546"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.773 12.723a1 1 0 0 1-.707-.293L6.142 9.506a1 1 0 0 1 1.414-1.414l2.217 2.217 9.041-9.041a1 1 0 0 1 1.414 1.414L10.48 12.43a1 1 0 0 1-.707.293"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6 19.546H2.95A2.953 2.953 0 0 1 0 16.6V2.95A2.953 2.953 0 0 1 2.95 0h10.722a1 1 0 1 1 0 2H2.95a.95.95 0 0 0-.95.95V16.6a.95.95 0 0 0 .95.95H16.6a.95.95 0 0 0 .95-.95V9.773a1 1 0 0 1 2 0V16.6a2.953 2.953 0 0 1-2.95 2.946"
  })));
};
export default SvgCheckedBox;